import React, { PureComponent } from "react";
import styled from "styled-components";
import * as d3 from "d3";
import _ from "lodash";
import classNames from "classnames";
import Text from "react-svg-text";
import { toast } from "react-toastify";
import SockJsClient from "react-stomp";
import CustomToast from "./Toast";
import {
  AllPhenomena,
  CreateRadarForm,
  AddPhenomenaSandbox,
  ConfirmDialog,
  SignalList,
  SideNav,
  ErrorModal,
  TimeRangeEditorForm,
  Filters,
} from "../containers";
import { Modal, SVGIcon, Loading } from "@futures-platform/ui";
import { getCoordsFromAngleAndRadius, detectLeftButton } from "../helpers";
import { PUBLIC_URL, RADAR_DATA_WEBSOCKET_URL } from "../env";
import { requestTranslation } from "@futures-platform/i18n";
import { PhenomenonEditForm } from "./PhenomenonEditForm/PhenomenonEditForm";
// import {PhenomenonEditForm} from '@futures-platform/content-editor'
import { PhenomenonLoader } from "@futures-platform/hooks";
// import { PhenomenonLoader } from './usePhenomenon'
import SectorEditorForm from "./SectorEditorForm";
import EditSectorMenu from "./EditSectorMenu";
import Phenomenon from "./Phenomenon";
import { modalStyles, paddingModalStyles } from "@futures-platform/ui";
import {
  centerRadiusPercentage,
  getWebSocketHeaders,
  timerangeColors,
  radarBorderWidth,
} from "../config";
import ReactDOM from "react-dom";
import { ExitFullscreen, Fullscreen } from "@styled-icons/boxicons-regular";
import ConfirmationModalFoCollabTool from "./ConfirmationModalForCollabTool/ConfirmationModalForCollabTool";
import PhenomenaTagSelector from "../containers/PhenomenaTagSelector";
import DeleteConfirmationModalForSector from "./DeleteConfirmationModalForSector/DeleteConfirmationModalForSector";
import { getSessionToken } from "@futures-platform/connectors/session";
import phenomena from "../reducers/phenomena";

var mainUrl =
  window.location != window.parent.location
    ? document.referrer
    : document.location.href;

var paramsString = document.location.search;
var searchParams = new URLSearchParams(paramsString);
var isAIFCreatePreviewRadar = !searchParams.get("node") ? true : false;
class RadarPage extends PureComponent {
  constructor(props) {
    super(props);
    const { containerWidth, containerHeight, svgDimensions } = props;
    const containerSize = Math.min(containerWidth, containerHeight);
    const zoomExtent = (containerSize / svgDimensions) * 0.8;
    this.zoom = d3
      .zoom()
      .scaleExtent([(containerSize / svgDimensions) * 0.5, zoomExtent + 4])
      .on("zoom", this.zoomed);
    this.state = {
      isOpenSelectorModal: false,
      isOpenDeleteSectorModal: false,
      isIconImgLoading: true,
      zoomExtent,
      sectorDescriptionModal: null,
      deleteRadarPhenomenonOpen: false,
      editSector: null,
      editMenuPosition: null,
      zoomTransform: {
        x: 0,
        y: 0,
        k: zoomExtent,
      },
      mouseCoords: {
        x: 0,
        y: 0,
        angle: 0,
        radius: 0,
        timeRange: null,
        sector: null,
        time: null,
      },
      phenomenaDragged: false,
      openCofirmationModalCollabTool: false,
      isInFullScreen:
        document.fullScreenElement || // alternative standard method
        document.mozFullScreen ||
        document.webkitIsFullScreen,
    };
    this.elmRadar = React.createRef();
    if (!!isAIFCreatePreviewRadar) {
      this.phenomena = sessionStorage.getItem("phenomena");
      this.radarName = sessionStorage.getItem("radarName");
    }
  }

  componentDidMount() {
    const {
      fetchRadar,
      getUserGroups,
      radarSettings: { existingRadarPage },
    } = this.props;

    getUserGroups().then(() => {
      // work around to hide the Cookie white bar when embedded radar to another website
      if (existingRadarPage) {
        const data = {
          phenomena: !!this.phenomena ? JSON.parse(this.phenomena) : [],
          radarName: this.radarName || null,
        };
        fetchRadar(data);
        // const cookieBar = document.getElementById('onetrust-accept-btn-handler')
        // if (!cookieBar) {
        //     localStorage.setItem('is-cookie-bar', false)
        // } else {
        //     localStorage.setItem('is-cookie-bar', true)
        // }
      }
    });

    this.attachEvents();
  }

  componentDidUpdate(prevProps) {
    if (this.shouldRadarRender() && !this.shouldRadarRender(prevProps)) {
      this.attachEvents();
    }

    // const ancestorOriginsForEmbededRadar = (window?.location.ancestorOrigins.length > 0
    //     && typeof window?.location.ancestorOrigins[0] === 'string') ? true : false
    if (
      !String(mainUrl).includes("go2.futuresplatform.com") &&
      !String(mainUrl).includes("access.futuresplatform.com")
    ) {
      try {
        var elementWrapperCookieBarExists = document?.getElementById(
          "onetrust-consent-sdk"
        );
        var elementExists = document?.getElementById("onetrust-banner-sdk");
        elementWrapperCookieBarExists.style.zIndex = 0;
        elementWrapperCookieBarExists.style.display = "none";
        elementExists.style.opacity = 0;
        elementExists.style.display = "none";
      } catch (error) {
        // console.log('case error')
      }
    }
  }

  zoomed = () => {
    const { phenomenaDragged } = this.state;

    if (!phenomenaDragged && this.isZoomable()) {
      this.setState({ zoomTransform: d3.event.transform });
    }
  };

  attachEvents() {
    const {
      zoomTransform: { k },
    } = this.state;
    const svg = d3.select(this.svg);

    svg
      .on("touchstart", this.handleMouseAction)
      .on("touchmove", this.handleMouseAction)
      .on("mousemove", this.handleMouseAction)
      .on("touchend", this.onPhenomenaDragEnd)
      .on("click", () => this.props.toggleEditMenuVisiblity(false))
      .call(this.zoom);

    this.zoom.scaleBy(svg, k);
  }

  handleResultsRedirect = () => {
    const {
      radarSettings: {
        id,
        editSectorsPageOpen,
        addRadarFormOpen,
        editPhenomenaVisible,
        signalListVisible,
        isVisitor,
      },
    } = this.props;
    // const renderRadarEditor = !editSectorsPageOpen && !addRadarFormOpen && !editPhenomenaVisible && !signalListVisible && !isVisitor
    // const isSafari = navigator.vendor
    //     && navigator.vendor.indexOf('Apple') > -1
    //     && navigator.userAgent
    //     && navigator.userAgent.indexOf('CriOS') == -1
    //     && navigator.userAgent.indexOf('FxiOS') == -1
    //     && !navigator.userAgent.match('FxiOS')

    // if (!!isSafari) {
    //     document.location.replace(`${PUBLIC_URL}/node/${id}/results`)
    // } else {
    //     window.location.href = `${PUBLIC_URL}/node/${id}/results`
    // }

    window.location.href = `${PUBLIC_URL}/node/${id}/results`;
  };

  isZoomable = () => !this.isEditorPageOpen();

  hideSectorMenuEdit = () => {
    if (!this.state.isOpenDeleteSectorModal) {
      this.setState({ editMenuPosition: null });
    }
  };

  showSectorEditMenu = ({ pageX, pageY }, sector) =>
    this.setState({
      editMenuPosition: {
        x: pageX,
        y: pageY,
        sector,
      },
    });
  handleEditPhenomenonFormClose = () =>
    this.props.changeEditPhenomenaVisibility();

  renderTimelines() {
    const { timeRanges, radius } = this.props;

    return (
      <g className={"time-ranges"}>
        <circle
          r={timeRanges[timeRanges.length - 1].outerRadius + radarBorderWidth}
          fill={"#F5F5F5"}
        />
        {timeRanges
          .slice()
          .reverse()
          .map(({ outerRadius }, index) => {
            const isLast = index === 0;

            return (
              <g key={index}>
                <circle
                  r={outerRadius}
                  fill={timerangeColors(index)}
                  strokeWidth={isLast ? 2 : 0}
                  stroke={"#979797"}
                  strokeDasharray={4}
                />
              </g>
            );
          })}
        {!timeRanges.length && <circle r={radius} fill={timerangeColors(4)} />}
      </g>
    );
  }

  renderPhenomena() {
    const { radius, timeRanges, draggedPhenomenon, group } = this.props;
    return (
      <AllPhenomena
        radius={radius}
        timeRanges={timeRanges}
        scaled={this.scaled}
        zoomTransform={this.state.zoomTransform}
        onPhenomenaDrag={!isAIFCreatePreviewRadar && this.onPhenomenaDrag}
        draggedPhenomenon={!isAIFCreatePreviewRadar && draggedPhenomenon}
        getPhenomenaDisplayProps={this.getPhenomenaDisplayProps}
        isAIFCreatePreviewRadar={isAIFCreatePreviewRadar}
      />
    );
  }

  renderSectors() {
    const { timeRanges, radius } = this.props;
    const {
      mouseCoords: { sector },
    } = this.state;
    const selectedKey = sector ? sector.key : 0;
    const fontSize = this.scaled(8.5);
    const { sectors: lastSectors } = _.last(timeRanges);

    return (
      <g className={"sectors"}>
        {timeRanges.map(({ sectors }) =>
          sectors.map(({ key, arc }) => (
            <path
              stroke={"transparent"}
              fill={selectedKey === key ? "#dededf" : "transparent"}
              key={key}
              className={"sector"}
              d={arc}
            />
          ))
        )}

        {lastSectors.map(({ id, key, title, startAngle, endAngle, notes }) => {
          const middleOfSectorAngle = (startAngle + endAngle) / 2 || 0;
          const offset = fontSize * 5;
          const width = radius * 0.25;

          const [x, y] = getCoordsFromAngleAndRadius(
            middleOfSectorAngle,
            radius + offset + radarBorderWidth
          );

          return (
            <g key={`sector-meta-${id}`}>
              <path
                key={key}
                stroke={"#909090"}
                fill={"#909090"}
                className={"sector"}
                strokeWidth="1"
                strokeDasharray={4}
                d={d3.radialLine()([
                  [startAngle, 0],
                  [startAngle, radius],
                ])}
              />
              <Text
                x={x}
                y={y}
                verticalAnchor={"middle"}
                className={"sector-label noselect"}
                width={width}
                textAnchor="middle"
                style={{
                  fontSize: `${fontSize}px`,
                }}
                onClick={() =>
                  this.setState({
                    sectorDescriptionModal: { notes, title },
                  })
                }
              >
                {title}
              </Text>
            </g>
          );
        })}
      </g>
    );
  }

  renderLogo() {
    const {
      timeRanges,
      radius,
      radarSettings: { radarImage },
      radarLogoLinkDisabled,
    } = this.props;
    const logoRadius = _.first(timeRanges)
      ? _.first(timeRanges).radius
      : radius * centerRadiusPercentage;
    const transform = `translate(${-logoRadius}, ${-logoRadius})`;
    const {
      radarSettings: { commentsOn, ratingsOn, votingOn, discussionOn },
    } = this.props;
    const isCollabToolsActivated =
      !!commentsOn || !!ratingsOn || !!votingOn || !!discussionOn;
    const isEmbedRadar =
      (!!window &&
        !!window.location &&
        !!window.location.ancestorOrigins?.length &&
        // && window.location.ancestorOrigins[0]
        window.location.hostname === "access.futuresplatform.com") ||
      localStorage.getItem("fp-vid") !== "undefined"
        ? true
        : false;

    return (
      <g>
        {!radarImage ? (
          <circle
            className="radar-logo"
            onClick={
              (!radarLogoLinkDisabled || !!isCollabToolsActivated) &&
              this.handleResultsRedirect
            }
            r={logoRadius}
            fill={"#126995"}
            style={
              !radarLogoLinkDisabled || !!isCollabToolsActivated
                ? { cursor: "pointer" }
                : null
            }
          />
        ) : (
          <foreignObject
            className="radar-logo"
            onClick={
              (!radarLogoLinkDisabled || !!isCollabToolsActivated) &&
              this.handleResultsRedirect
            }
            width={logoRadius * 2}
            height={logoRadius * 2}
            transform={transform}
            style={
              !radarLogoLinkDisabled || !!isCollabToolsActivated
                ? { cursor: "pointer" }
                : null
            }
          >
            <img
              alt="logo"
              src={
                !isEmbedRadar
                  ? radarImage
                  : `${radarImage}?access_token=${getSessionToken()}`
              }
              style={{
                width: logoRadius * 2,
                height: logoRadius * 2,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </foreignObject>
        )}
      </g>
    );
  }

  getTimerangeLabelPath(radius) {
    return `
            M 0, 0
            m -${radius}, 0
            a ${radius},${radius} 0 1,0 ${radius * 2},0
        `;
  }

  renderTimelineTooltip() {
    const {
      timelines,
      timeRanges,
      radarSettings: { timelineLabelFormat },
    } = this.props;
    const { scaled } = this;
    const fontSize = scaled(9);
    const strokeWidth = scaled(4);
    const tooltipHeight = scaled(16.5);

    return (
      <g className={"timeline"}>
        {timeRanges.map((timeRange, index) => {
          const isLast = index === timeRanges.length - 1;
          const tooltipY = timeRange.radius;
          const {
            description,
            startYear,
            endYear,
            outerRadius,
            label,
            radius,
          } = timeRange;
          const line = d3.radialLine()([
            [Math.PI, radius + tooltipHeight],
            [Math.PI, outerRadius],
          ]);

          return (
            <g key={`tooltips-${index}`}>
              <path d={line} stroke={"#8d8e92"} strokeWidth={strokeWidth} />
              {!timeRange.isPlaceholder && (
                <g>
                  <g>
                    <path
                      d={this.getTimerangeLabelPath(tooltipY + tooltipHeight)}
                      id={`timerange-label-${index}`}
                      fill="transparent"
                      style={{ pointerEvents: "none" }}
                    />
                    <text
                      dy={-tooltipHeight / 4}
                      className={"hoverable timeline-label-text noselect"}
                      style={{ fontSize: `${fontSize}px` }}
                      onClick={() =>
                        this.setState({
                          sectorDescriptionModal: {
                            notes: description,
                            title: timelineLabelFormat ? label : startYear,
                          },
                        })
                      }
                    >
                      <textPath
                        xlinkHref={`#timerange-label-${index}`}
                        textAnchor="middle"
                        startOffset="50%"
                      >
                        {timelineLabelFormat ? label : startYear}
                      </textPath>
                    </text>
                  </g>
                  {isLast && (
                    <g>
                      <path
                        id="timerange-label-last"
                        d={this.getTimerangeLabelPath(
                          outerRadius + tooltipHeight
                        )}
                        fill={"transparent"}
                        style={{ pointerEvents: "none" }}
                      />
                      <text
                        dy={-tooltipHeight / 4}
                        className={"hoverable timeline-label-text noselect"}
                        style={{ fontSize: `${fontSize}px` }}
                        onClick={() => {
                          this.setState({
                            sectorDescriptionModal: {
                              notes:
                                timelines[timelines.length - 1].description,
                              title: timelineLabelFormat
                                ? timelines[timelines.length - 1].label
                                : endYear,
                            },
                          });
                        }}
                      >
                        <textPath
                          xlinkHref={`#timerange-label-last`}
                          textAnchor="middle"
                          startOffset="50%"
                        >
                          {timelineLabelFormat
                            ? timelines[timelines.length - 1].label
                            : endYear}
                        </textPath>
                      </text>
                    </g>
                  )}
                </g>
              )}
            </g>
          );
        })}
      </g>
    );
  }

  shouldRadarRender(props = this.props) {
    const { timeRanges } = props;

    return timeRanges.length !== 0 && !this.isEditorPageOpen(props);
  }

  renderRadar = () => {
    const { containerWidth, containerHeight } = this.props;
    const {
      zoomTransform: { x, y, k },
      phenomenaDragged,
    } = this.state;
    const classes = classNames({
      "zoomed-out": k < 0.25,
      "zoomed-out-far": k < 0.15,
    });
    const isWidthLessThan500pxLocal = matchMedia("(max-width: 500px)").matches;
    const extraX = !!isAIFCreatePreviewRadar
      ? !isWidthLessThan500pxLocal
        ? 100
        : 20
      : 0;
    const xTemp = x + extraX;
    const extraY = !!isAIFCreatePreviewRadar ? 20 : 0;
    const yTemp = y + extraY;
    const kTemp = !!isAIFCreatePreviewRadar ? 0.8 * k : k;
    return (
      this.shouldRadarRender() && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          ref={this.svgRef}
          height={containerHeight}
          width={containerWidth}
          className={classes}
          style={{ zIndex: phenomenaDragged ? 1 : 0 }}
        >
          <g
            className="zoom-control"
            transform={`translate(${xTemp}, ${yTemp}) scale(${kTemp})`}
          >
            <g
              ref={this.radarRef}
              transform={`translate(${containerWidth / 2}, ${
                containerHeight / 2
              })`}
            >
              {this.renderTimelines()}
              {this.renderSectors()}
              {this.renderTimelineTooltip()}
              {this.renderLogo()}
              {this.renderPhenomena()}
              {this.renderDragMarker()}
            </g>
          </g>
        </svg>
      )
    );
  };

  renderMenuLink = (
    x,
    y,
    onClick,
    radius = this.scaled(25),
    fontSize = this.scaled(14)
  ) => (
    <g key={x + y} onClick={onClick} className={"tooltip-edit"}>
      <circle r={radius / 2} cx={x} cy={y} fill={"#126995"} stroke={"none"} />
      <SVGIcon x={x} y={y} fontSize={fontSize} icon={"edit"} />
    </g>
  );

  renderEditabilityTooltip = (sector, index, offset) => {
    const middleOfSectorAngle = (sector.startAngle + sector.endAngle) / 2 || 0;
    const toolTipOffset = Math.min(offset * 0.15, 100);
    const [x, y] = getCoordsFromAngleAndRadius(
      middleOfSectorAngle,
      offset - toolTipOffset
    );

    return this.renderMenuLink(x, y, (e) => this.showSectorEditMenu(e, sector));
  };

  renderSectorEditor = () => {
    const {
      containerWidth,
      containerHeight,
      timeRanges,
      radius,
      updateSector,
      radarSettings: { editSectorsPageOpen },
      canEditRadar,
    } = this.props;

    if (!canEditRadar) {
      return null;
    }

    const { sectors: lastSectors, outerRadius: lastRadius } =
      _.last(timeRanges);
    const { editSector, zoomExtent } = this.state;
    const transform = `translate(${containerWidth / 2}, ${
      containerHeight / 2
    }) scale(${zoomExtent})`;

    return (
      editSectorsPageOpen && (
        <div>
          <Modal
            isOpen={!!editSector}
            onRequestClose={() => {
              this.setState({ editSector: null });
            }}
            contentLabel="Sector settings"
            style={modalStyles}
            ariaHideApp={false}
          >
            <SectorEditorForm
              sector={editSector}
              onClose={() => {
                this.setState({ editSector: null });
              }}
              updateSector={updateSector}
            />
          </Modal>
          <svg height={containerHeight} width={containerWidth} fill="black">
            <g transform={transform}>
              <circle
                stroke={"#D9D9D9"}
                fill={"rgb(15, 19, 24)"}
                r={lastRadius}
              />
              {this.renderSectors()}
              {lastSectors.map((sector, index) =>
                this.renderEditabilityTooltip(sector, index, lastRadius)
              )}
              {!lastSectors.length &&
                this.renderEditabilityTooltip({}, 1, radius)}
            </g>
          </svg>
        </div>
      )
    );
  };

  isEditorPageOpen(props = this.props) {
    const {
      radarSettings: { editSectorsPageOpen },
    } = props;

    return editSectorsPageOpen;
  }

  scaled = (value) => {
    const {
      zoomExtent,
      zoomTransform: { k },
    } = this.state;

    if (!this.isZoomable()) {
      return value / (zoomExtent / 1.4);
    }

    const divisor = Math.max(k, 0.25);

    return value / (divisor / 1.4);
  };

  onPhenomenaDrag = (e, phenomenon, newlyCreated = false) => {
    const { setDraggedPhenomenon, canEditRadar } = this.props;

    if (e) {
      e.stopPropagation();
    }
    // const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (
      newlyCreated ||
      (detectLeftButton(e) && e) ||
      "ontouchstart" in document.documentElement ||
      "ontouchstart" in window
    ) {
      this.setState({ updatingPhenomena: phenomenon });

      this.longpressTimeout = setTimeout(() => {
        if (canEditRadar) {
          this.setState({ phenomenaDragged: true });
          setDraggedPhenomenon(phenomenon);
          document.removeEventListener("mousedown", this.onPhenomenaDragEnd);
        }
      }, 400);

      document.addEventListener("mouseup", this.onPhenomenaDragEnd);
      document.addEventListener("mousedown", this.onPhenomenaDragEnd);

      document.addEventListener("touchend", this.onPhenomenaDragEnd);
      document.addEventListener("touchcancel", this.onPhenomenaDragEnd);
      document.addEventListener("pointerup", this.onPhenomenaDragEnd);

      if (!!isSafari && !!newlyCreated) {
        document.removeEventListener("mousedown", this.onPhenomenaDragEnd);

        document.removeEventListener("mouseup", this.onPhenomenaDragEnd);
        const fnTemp = (event) => {
          event.preventDefault();
          event.stopPropagation();
          setTimeout(() => {
            document.removeEventListener("mousedown", fnTemp, true);
          }, 300);
        };
        document.addEventListener("mousedown", fnTemp, true);
      }

      // safari fix for when adding phenom
      // It does not work on Safari anymore when it is React 18 or over.
      !!isSafari && document.addEventListener("click", this.onPhenomenaDragEnd);
    }
  };

 handleMouseAction = () => {
    const { timeRanges, radius: radarRadius } = this.props;

    // d3.event.preventDefault()

    if (!this.isEditorPageOpen()) {
      const [x, y] = d3.mouse(this.radar);
      const radians = Math.atan2(y, x);
      const angle =
        radians < Math.PI / 2
          ? radians + Math.PI * 2.5
          : radians + Math.PI * 0.5;
      const radius = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
      const isOutside = radius > radarRadius;
      const timeRange = _.find(
        timeRanges,
        ({ radius: innerRadius, outerRadius }) =>
          radius >= innerRadius && radius < outerRadius
      );
      const sector =
        timeRange &&
        _.find(
          timeRange.sectors,
          ({ startAngle, endAngle }) => angle >= startAngle && angle < endAngle
        );
      const outerTimeRange = isOutside
        ? _.last(timeRanges)
        : _.first(timeRanges);
      const boundaryRadius = isOutside
        ? outerTimeRange.outerRadius
        : outerTimeRange.radius;
      const boundaryTime = isOutside
        ? outerTimeRange.endYear + 0.00001
        : outerTimeRange.startYear + 0.00001;
      const outerSector = _.find(
        outerTimeRange.sectors,
        ({ startAngle, endAngle }) => angle >= startAngle && angle < endAngle
      );
      const time = timeRange && timeRange.scale.invert(radius);
      const xOffset = sector
        ? d3
            .scaleLinear()
            .range([0, 1])
            .domain([sector.startAngle, sector.endAngle])
            .interpolate(d3.interpolate)(angle)
        : 0.5;

      this.setState({
        mouseCoords: {
          x,
          y,
          isOutside,
          xOffset,
          angle,
          radius,
          timeRange,
          sector,
          time,
          outerSector,
          boundaryTime,
          boundaryRadius,
        },
      });
    }
  };

  onPhenomenaDragEnd = (e) => {
    const {
      updatePhenomenon,
      setDraggedPhenomenon,
      draggedPhenomenon: phenomenon,
    } = this.props;
    if (this.longpressTimeout) {
      clearTimeout(this.longpressTimeout);
    }

    if (phenomenon) {
      const {
        mouseCoords: { time, angle, sector, xOffset },
      } = this.state;
      const deleting = !sector;

      if (deleting) {
        this.setState({ deleteRadarPhenomenonOpen: phenomenon });
      } else {
        updatePhenomenon(phenomenon, {
          sectorId: sector.id,
          xOffset,
          time,
          angle,
        });
      }

      // this.setState({ phenomenaDragged: false })
      // setDraggedPhenomenon(false)

      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    if (
      e &&
      ("ontouchstart" in document.documentElement || "ontouchstart" in window)
    ) {
      e.preventDefault();
      e.stopPropagation();
    }

    // Move setState here to set phenomenaDragged
    // to fix drag phenomenon === null case, when other user(s) added that phenemenon before
    // this current user added/drag to Radar
    this.setState({ phenomenaDragged: false });
    setDraggedPhenomenon(false);

    document.removeEventListener("mouseup", this.onPhenomenaDragEnd);
    document.removeEventListener("pointerup", this.onPhenomenaDragEnd);
    document.removeEventListener("touchcancel", this.onPhenomenaDragEnd);
    document.removeEventListener("touchend", this.onPhenomenaDragEnd);
    document.removeEventListener("click", this.onPhenomenaDragEnd);
  };

  svgRef = (ref) => (this.svg = ref);
  radarRef = (ref) => (this.radar = ref);

  getPhenomenaDisplayProps = () => {
    const { radius, phenomenaTypesById } = this.props;
    // this can't be scaled due to react-svg-text calculation mechanisms
    const labelWidth = radius * 0.25;
    const labelHeight = this.scaled(30);
    const phenomenaSize = this.scaled(21);
    const iconSize = this.scaled(21);
    const fontSize = this.scaled(8);

    return {
      labelWidth,
      labelHeight,
      phenomenaSize,
      iconSize,
      fontSize,
      phenomenaTypesById,
    };
  };

  renderDragMarker() {
    const { draggedPhenomenon } = this.props;

    if (draggedPhenomenon) {
      if (!this.phenomenaDisplayProps) {
        this.phenomenaDisplayProps = this.getPhenomenaDisplayProps();
      }

      const {
        mouseCoords: { sector, x, y },
      } = this.state;

      return (
        <Phenomenon
          radarGroupId={this.props.radarSettings?.group?.id}
          cx={x}
          cy={y}
          phenomenon={draggedPhenomenon}
          deleting={!sector}
          dragged={true}
          {...this.phenomenaDisplayProps}
          scaled={this.scaled}
        />
      );
    } else if (this.phenomenaDisplayProps) {
      this.phenomenaDisplayProps = null;
    }
    return null;
  }

  hideAddForm = () => {
    this.setState(
      {
        // createModalShown: false,
        editModal: null,
      },
      () => {
        this.props.updateStoredPhenonSelector(null);
        this.props.setPhenomenonToTag(false);
      }
    );
  };

  handleOpenTagSelectorModal = (isOpenModal) => {
    this.setState({
      isOpenSelectorModal: isOpenModal,
    });
  };

  renderEditPhenomenonForm() {
    const {
      radarSettings: { editPhenomenaVisible, id, group, radarLanguage },
      storePhenomenon,
      phenomenonToTagFromStore,
    } = this.props;

    return (
      <Modal
        isOpen={!!editPhenomenaVisible}
        contentLabel={"Edit phenomena"}
        style={modalStyles}
        onRequestClose={this.handleEditPhenomenonFormClose}
        ariaHideApp={false}
      >
        {editPhenomenaVisible && (
          <PhenomenonLoader
            id={editPhenomenaVisible.id}
            group={editPhenomenaVisible.group || editPhenomenaVisible.groups[0]}
          >
            {({ loading, error, phenomenon }) => {
              if (loading) {
                return <div className="py-5 text-center">Loading...</div>;
              }

              if (error) {
                return (
                  <div className="py-5 text-center text-danger">
                    {error.message}
                  </div>
                );
              }

              return (
                <>
                  <>
                    {!!this.state.isOpenSelectorModal && (
                      <PhenomenaTagSelector
                        group={group.id || 0}
                        language={radarLanguage || "en"}
                        isInEditMode={true}
                        editModal={true}
                        phenData={phenomenon || editPhenomenaVisible}
                        setPhenomenonToTag={this.props.setPhenomenonToTag}
                      />
                    )}
                  </>
                  <PhenomenonEditForm
                    isUpdate={true}
                    phenomenon={phenomenonToTagFromStore || phenomenon}
                    createOrEditMode={true}
                    // onSubmit={(values, newsFeedChanges) => {
                    //     storePhenomenon(values, newsFeedChanges, this.handleEditPhenomenonFormClose)
                    // }}
                    onCancel={this.handleEditPhenomenonFormClose}
                    onDelete={() => {}}
                    radar={{
                      id,
                      groupId: group.id,
                      language: radarLanguage,
                    }}
                    handleOpenTagSelectorModal={this.handleOpenTagSelectorModal}
                    editModal={this.state.editModal}
                    storedPhenSelector={
                      this.props.storedPhenSelector ||
                      editPhenomenaVisible ||
                      phenomenon
                    }
                    setPhenomenonToTag={this.props.setPhenomenonToTag}
                    onSubmit={(values, newsFeedChanges) => {
                      // eslint-disable-next-line no-unused-expressions

                      values["tags"] = editPhenomenaVisible?.tags;
                      storePhenomenon(values, newsFeedChanges, (phenomenon) => {
                        this.setState({
                          editModal: null,
                          // indexForTagging: indexForTagging
                        });
                        this.hideAddForm();
                        this.props.setPhenomenonToTag(false);
                        this.handleEditPhenomenonFormClose();
                        // updateStoredPhenonSelector({...phenomenon})
                        // changeAddPhenomenaVisibility()
                        // onPhenomenaDrag(false, phenomenon, true)
                      });
                    }}
                    // radar={radar}
                  />
                </>
              );
            }}
          </PhenomenonLoader>
        )}
      </Modal>
    );
  }

  handleWebsocketUpdate = (update) => {
    const {
      radarSettings: { radar_version },
      refetchRadarData,
    } = this.props;

    if (update.radar_version !== radar_version) {
      refetchRadarData().then(() =>
        toast(requestTranslation("radarUpdated"), {
          toastId: "1",
        })
      );
    }
  };

  renderSockJsClient() {
    const { account, id } = this.props.radarSettings;

    return (
      account &&
      id && (
        <SockJsClient
          url={RADAR_DATA_WEBSOCKET_URL}
          topics={[`/topic/radar/${id}`]}
          onMessage={(update) =>
            setTimeout(
              function () {
                this.handleWebsocketUpdate(update);
              }.bind(this),
              500
            )
          }
          headers={getWebSocketHeaders()}
        />
      )
    );
  }

  renderBottomLeftNav() {
    const {
      radarSettings: { editSectorsPageOpen },
      radarLogoLinkDisabled,
    } = this.props;

    return (
      !editSectorsPageOpen && <Filters hideInfoButton={radarLogoLinkDisabled} />
    );
  }

    renderTitle() {
        const { radarName, groups, group, titleLogo } = this.props.radarSettings
        const renderTitleLogoInput = _.find(groups, ({ value }) => Number(value) === Number(group.id))
        const isWidthLessThan500pxLocal = matchMedia('(max-width: 500px)').matches
        return (
            <>
            {
                renderTitleLogoInput && renderTitleLogoInput.radarLogoEnabled && titleLogo
                ?
                (<RadarTitleLogo src={titleLogo} />)
                : null 
            }
            {
                (radarName && <RadarTitle id='radar-title-left' style={{
                    color: !!isAIFCreatePreviewRadar && '#121212',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: !!isAIFCreatePreviewRadar &&  !isWidthLessThan500pxLocal ?   '40%' : '100%',
                    height: !!isAIFCreatePreviewRadar && '100%',
                    margin: !!isAIFCreatePreviewRadar && 0,
                    top: (renderTitleLogoInput && renderTitleLogoInput.radarLogoEnabled && titleLogo) ? '110px' : 0,
                }}>{radarName}</RadarTitle>)
            }
            </>
        )
    }


  // this really needs to be rewritten
  renderEditSectorMenu() {
    const { editMenuPosition, isOpenDeleteSectorModal } = this.state;
    const { timeRanges, addSector, deleteSector } = this.props;

    const openDeleteSectorModal = () => {
      this.setState({ isOpenDeleteSectorModal: true });
    };

    const closeDeleteSectorModal = () => {
      this.setState({ isOpenDeleteSectorModal: false }, () => {
        this.hideSectorMenuEdit();
      });
    };

    return (
      <>
        {editMenuPosition && (
          <EditSectorMenu
            timeranges={timeRanges}
            handleEditSectorForm={() => {
              this.setState({ editSector: editMenuPosition.sector });
              this.hideSectorMenuEdit();
            }}
            y={editMenuPosition.y}
            x={editMenuPosition.x}
            sector={editMenuPosition.sector}
            onClose={this.hideSectorMenuEdit}
            deleteSector={(sectorId) => {
              deleteSector(sectorId);
              this.hideSectorMenuEdit();
            }}
            addSector={(direction, sectorId) => {
              addSector(direction, sectorId);
              this.hideSectorMenuEdit();
            }}
            openDeleteSectorModal={openDeleteSectorModal}
          />
        )}
        {!!isOpenDeleteSectorModal && (
          <DeleteConfirmationModalForSector
            sector={editMenuPosition?.sector}
            deleteSectorHandler={(sectorId) => {
              deleteSector(sectorId);
              closeDeleteSectorModal();
              this.hideSectorMenuEdit();
            }}
            deleteConfirmationModal={isOpenDeleteSectorModal}
            deleteConfirmationModalClose={closeDeleteSectorModal}
            fetchRadar={this.props.fetchRadar}
          />
        )}
      </>
    );
  }

  renderCreateRadarModal() {
    const {
      changeAddRadarFormVisibility,
      radarSettings: { addRadarFormOpen, id },
    } = this.props;

    const oldAxis = {
      xAxisName: this.props.radarSettings.axisXTitle,
      yAxisName: this.props.radarSettings.axisYTitle,
    };

    sessionStorage.setItem("old-axis", JSON.stringify({ ...oldAxis }));
    const { openCofirmationModalCollabTool } = this.state;

    const openCofirmationModalCollabToolHandle = () => {
      const currentStates = JSON.parse(sessionStorage.getItem("state"));
      const chartData = JSON.parse(sessionStorage.getItem("chartData"));

      if (!this.props.radarSettings.ratingsOn) {
        if (
          this.props.radarSettings.displayHaloWhenRating !==
            currentStates.displayHaloWhenRating ||
          this.props.radarSettings.discussionOn !==
            currentStates.discussionOn ||
          this.props.radarSettings.votingOn !== currentStates.votingOn ||
          this.props.radarSettings.ratingsOn !== currentStates.ratingsOn ||
          // || (this.props.radarSettings.votingHaloOn !== currentStates.votingHaloOn)
          this.props.radarSettings.likingOn !== currentStates.discussionOn ||
          this.props.radarSettings.commentsOn !== currentStates.commentsOn
        ) {
          // in case data modified
          this.setState({
            openCofirmationModalCollabTool: true,
          });
        } else {
          // in case data NOT modified
          this.setState({
            openCofirmationModalCollabTool: false,
          });
          changeAddRadarFormVisibility();
        }
      } else if (
        !this.props.radarSettings?.axisYTitle &&
        !this.props.radarSettings?.axisXMax
      ) {
        if (
          this.props.radarSettings.displayHaloWhenRating !==
            currentStates.displayHaloWhenRating ||
          this.props.radarSettings.discussionOn !==
            currentStates.discussionOn ||
          this.props.radarSettings.votingOn !== currentStates.votingOn ||
          this.props.radarSettings.ratingsOn !== currentStates.ratingsOn ||
          // || (this.props.radarSettings.votingHaloOn !== currentStates.votingHaloOn)
          this.props.radarSettings.likingOn !== currentStates.discussionOn ||
          this.props.radarSettings.commentsOn !== currentStates.commentsOn ||
          null !== currentStates.fourFieldsBottomLeft ||
          null !== currentStates.fourFieldsBottomRight ||
          null !== currentStates.fourFieldsTopLeft ||
          null !== currentStates.fourFieldsTopRight ||
          null !== currentStates.axisXTitle ||
          null !== currentStates.axisXMin ||
          null !== currentStates.axisYTitle ||
          null !== currentStates.axisXMax ||
          null !== currentStates.axisYMin ||
          null !== currentStates.axisYMax
        ) {
          // in case data modified
          this.setState({
            openCofirmationModalCollabTool: true,
          });
        } else {
          // in case data NOT modified
          this.setState({
            openCofirmationModalCollabTool: false,
          });
          changeAddRadarFormVisibility();
        }
      } else {
        const currentStates = JSON.parse(sessionStorage.getItem("state"));
        const chartData = JSON.parse(sessionStorage.getItem("chartData"));
        let fourFieldsBottomLeft = chartData
          ? String(chartData?.bottomLeftValue)
          : String(currentStates.fourFieldsBottomLeft);
        let fourFieldsBottomRight = chartData
          ? String(chartData?.bottomRightValue)
          : String(currentStates.fourFieldsBottomRight);
        let fourFieldsTopLeft = chartData
          ? String(chartData?.topLeftValue)
          : String(currentStates.fourFieldsTopLeft);
        let fourFieldsTopRight = chartData
          ? String(chartData?.topRightValue)
          : String(currentStates.fourFieldsTopRight);
        let axisXTitle = chartData
          ? String(chartData?.horizontalAxisNameValue)
          : String(currentStates.axisXTitle);
        let axisYTitle = chartData
          ? String(chartData?.verticalAxisNameValue)
          : String(currentStates.axisYTitle);
        let axisXMin = chartData
          ? String(chartData?.leftEndValue)
          : String(currentStates.axisXMin);
        let axisXMax = chartData
          ? String(chartData?.rightEndValue)
          : String(currentStates.axisXMax);
        let axisYMin = chartData
          ? String(chartData?.lowEndValue)
          : String(currentStates.axisYMin);
        let axisYMax = chartData
          ? String(chartData?.topEndValue)
          : String(currentStates.axisYMax);

        if (
          this.props.radarSettings.displayHaloWhenRating !==
            currentStates.displayHaloWhenRating ||
          this.props.radarSettings.discussionOn !==
            currentStates.discussionOn ||
          this.props.radarSettings.votingOn !== currentStates.votingOn ||
          this.props.radarSettings.ratingsOn !== currentStates.ratingsOn ||
          // || (this.props.radarSettings.votingHaloOn !== currentStates.votingHaloOn)
          this.props.radarSettings.likingOn !== currentStates.discussionOn ||
          this.props.radarSettings.commentsOn !== currentStates.commentsOn ||
          this.props.radarSettings.fourFieldsBottomLeft !==
            fourFieldsBottomLeft ||
          this.props.radarSettings.fourFieldsBottomRight !==
            fourFieldsBottomRight ||
          this.props.radarSettings.fourFieldsTopLeft !== fourFieldsTopLeft ||
          this.props.radarSettings.fourFieldsTopRight !== fourFieldsTopRight ||
          this.props.radarSettings.axisXTitle !== axisXTitle ||
          this.props.radarSettings.axisXMin !== axisXMin ||
          this.props.radarSettings.axisYTitle !== axisYTitle ||
          this.props.radarSettings.axisXMax !== axisXMax ||
          this.props.radarSettings.axisYMin !== axisYMin ||
          this.props.radarSettings.axisYMax !== axisYMax
        ) {
          // in case data modified
          this.setState({
            openCofirmationModalCollabTool: true,
          });
        } else {
          // in case data NOT modified
          this.setState({
            openCofirmationModalCollabTool: false,
          });
          changeAddRadarFormVisibility();
        }
      }
    };

    const closeCofirmationModalCollabToolHandle = () => {
      this.setState({
        openCofirmationModalCollabTool: false,
      });
    };

    const handleNextClickTriggered = (func) => {
      this.setState({
        func: func,
      });
    };

    return (
      <Modal
        isOpen={addRadarFormOpen}
        contentLabel="Radar settings"
        style={modalStyles}
        ariaHideApp={false}
        // onRequestClose={id ? () => changeAddRadarFormVisibility : null}
        onRequestClose={
          id
            ? () => {
                // changeAddRadarFormVisibility();
                openCofirmationModalCollabToolHandle();
              }
            : null
        }
      >
        <CreateRadarForm handleNextClickTriggered={handleNextClickTriggered} />
        <ConfirmationModalFoCollabTool
          ConfirmationModalNote={requestTranslation("closeCollabToolNote")}
          confirmationModal={openCofirmationModalCollabTool}
          yesConfirmationHandleBtn={() => {
            changeAddRadarFormVisibility();
            closeCofirmationModalCollabToolHandle();
          }}
          noConfirmationHandleBtn={closeCofirmationModalCollabToolHandle}
          saveConfirmationHandleBtn={() => {
            closeCofirmationModalCollabToolHandle();
            this.state.func && this.state.func();
          }}
          isSaveConfirmationHandleBtnExist={true}
        />
      </Modal>
    );
  }

  renderSectorDescriptionModal() {
    const { sectorDescriptionModal } = this.state;

    return (
      <Modal
        isOpen={!!sectorDescriptionModal}
        contentLabel="Sector description"
        onRequestClose={() => this.setState({ sectorDescriptionModal: null })}
        style={modalStyles}
        ariaHideApp={false}
      >
        {!!sectorDescriptionModal && (
          <div>
            <div className="modal-form-sections">
              <div className="modal-form-section modal-form-header">
                <h2>{sectorDescriptionModal.title}</h2>
              </div>
              <div className="modal-form-section">
                <div
                  dangerouslySetInnerHTML={{
                    __html: sectorDescriptionModal.notes,
                  }}
                />
              </div>
            </div>

            <div className="modal-form-section modal-form-actions pt-0">
              <div
                onClick={() => this.setState({ sectorDescriptionModal: null })}
                className="btn btn-lg btn-primary"
              >
                {requestTranslation("close")}
              </div>
            </div>
          </div>
        )}
      </Modal>
    );
  }

  renderDeleteRadarPhenomenonModal() {
    const { deleteRadarPhenomenonOpen } = this.state;
    const { deleteRadarPhenomenon } = this.props;

    return (
      <Modal
        isOpen={!!deleteRadarPhenomenonOpen}
        contentLabel="Delete phenomena from radar"
        style={paddingModalStyles}
        className={"paddedModal"}
        ariaHideApp={false}
      >
        <div className={"confirmation-modal-content"}>
          <h3 className={"confirmation-modal-title"}>
            {requestTranslation("deletePhenomenaDoubleCheck")}
          </h3>
          <div className={"confirmation-modal-actions"}>
            <button
              className="btn btn-lg btn-plain-gray"
              onClick={() => {
                // is already on radar
                if (deleteRadarPhenomenonOpen.time) {
                  this.setState({ deleteRadarPhenomenonOpen: false });
                  // need to add it to radar again and set it as dragged
                } else {
                  this.onPhenomenaDrag(false, deleteRadarPhenomenonOpen, true);
                  this.setState({ deleteRadarPhenomenonOpen: false });
                }
              }}
            >
              {requestTranslation("cancel")}
            </button>
            <button
              className="btn btn-lg btn-primary"
              onClick={() =>
                deleteRadarPhenomenon(deleteRadarPhenomenonOpen, () =>
                  this.setState({ deleteRadarPhenomenonOpen: false })
                )
              }
            >
              {requestTranslation("delete")}
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  renderSandbox() {
    const {
      setDraggedPhenomenon,
      radarSettings: { addPhenomenaVisible },
    } = this.props;
    const { phenomenaDragged } = this.state;

    if (addPhenomenaVisible) {
      return (
        <AddPhenomenaSandbox
          {...this.props}
          onPhenomenaDrag={(...args) => {
            this.setState({ phenomenaDragged: true });
            this.onPhenomenaDrag(...args);
            setDraggedPhenomenon(args[1]);
          }}
          updateMouseCoords={this.handleMouseAction}
          placing={!!phenomenaDragged}
        />
      );
    }

    return null;
  }

  getParentByTag = (elem, lookingFor) => {
    lookingFor = lookingFor.toUpperCase();
    while ((elem = elem.parentNode))
      if (elem.tagName === lookingFor) return elem;
  };

  // allowfullscreen
  handleFullscreen = () => {
    this.setState(
      {
        isInFullScreen: true,
      },
      () => {
        const isNotInFullScreen =
          !document.fullScreenElement && // alternative standard method
          !document.mozFullScreen &&
          !document.webkitIsFullScreen &&
          !document.msRequestFullscreen;

        const node = ReactDOM.findDOMNode(this);
        // var docElm = document.documentElement;
        const docElm = this.getParentByTag(node, "body");
        try {
          if (!!isNotInFullScreen) {
            if (docElm.requestFullscreen) {
              docElm.requestFullscreen();
            } else if (docElm.mozRequestFullScreen) {
              docElm.mozRequestFullScreen();
            } else if (docElm.webkitRequestFullScreen) {
              docElm.webkitRequestFullScreen();
            } else if (docElm.msRequestFullscreen) {
              /* IE11 */
              docElm.msRequestFullscreen();
            }
          } else {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
              /* Safari */
              document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
              /* IE11 */
              document.msExitFullscreen();
            } else if (document.cancelFullScreen) {
              /* Safari */
              document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
              /* Safari */
              document.mozCancelFullScreen();
            } else if (document.cancelFullScreen) {
              /* Safari */
              document.cancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
              /* Safari */
              document.webkitCancelFullScreen();
            }
          }
        } catch (error) {}
      }
    );
  };

  handleExitFullScreen = () => {
    this.setState(
      {
        isInFullScreen: false,
      },
      () => {
        try {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            /* Safari */
            document.webkitExitFullscreen();
          } else if (document.msExitFullscreen) {
            /* IE11 */
            document.msExitFullscreen();
          } else if (document.cancelFullScreen) {
            /* Safari */
            document.cancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            /* Safari */
            document.mozCancelFullScreen();
          } else if (document.cancelFullScreen) {
            /* Safari */
            document.cancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            /* Safari */
            document.webkitCancelFullScreen();
          }
        } catch (error) {}
      }
    );
  };

  render() {
    const uA = navigator.userAgent;
    const vendor = navigator.vendor;
    const isSafari =
      /Safari/i.test(uA) &&
      /Apple Computer/.test(vendor) &&
      !/Mobi|Android/i.test(uA);
    const prefixes = !!isSafari ? "webkit" : "";
    const isFullScreen = () => {
      return !!(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    };
    const isFullScreenInSafari = () => {
      // eslint-disable-next-line no-restricted-globals
      return Math.abs(screen.width - window.innerWidth) < 10;
    };
    const fullscreenchanged = () => {
      if (
        (!isFullScreen() || !isFullScreenInSafari()) &&
        !!this.state.isInFullScreen
      ) {
        this.setState({
          isInFullScreen: false,
        });
      }
    };
    document.addEventListener(prefixes + "fullscreenchange", fullscreenchanged);

    const { loading, returnUri } = this.props;

    const { isInFullScreen } = this.state;

    // const ancestorOriginsForEmbededRadar = (window?.location.ancestorOrigins.length > 0
    //     && typeof window?.location.ancestorOrigins[0] === 'string') ? true : false

    if (
      !String(mainUrl).includes("go2.futuresplatform.com") &&
      !String(mainUrl).includes("access.futuresplatform.com")
    ) {
      try {
        var elementWrapperCookieBarExists = document?.getElementById(
          "onetrust-consent-sdk"
        );
        var elementExists = document?.getElementById("onetrust-banner-sdk");
        elementWrapperCookieBarExists.style.zIndex = 0;
        elementWrapperCookieBarExists.style.display = "none";
        elementExists.style.opacity = 0;
        elementExists.style.display = "none";
      } catch (error) {
        // console.log('case error')
      }
    }

    const { radarSettings: { phenomena }, timeRanges} = this.props

    function hasTimeOutsidePeriod(arrayA, arrayB) {
      if (!arrayA?.length) {
        return false;
      } else if (!!arrayA?.length && !arrayB?.length) {
        return true;
      }
    
      // Find the global min startYear and max endYear across all items in arrayB
      let globalStartYear = Infinity;
      let globalEndYear = -Infinity;
    
      arrayB.forEach(item => {
        if (typeof item.startYear === "number" && typeof item.endYear === "number") {
          globalStartYear = Math.min(globalStartYear, item.startYear);
          globalEndYear = Math.max(globalEndYear, item.endYear);
        }
      });
    
      // If no valid periods found in arrayB
      if (globalStartYear === Infinity || globalEndYear === -Infinity) {
        return true;
      }
    
      // Check if any item in arrayA has a time outside the allowed period
      return arrayA.some(item => {
        const time = item.time;
        return typeof time === "number" && (time < globalStartYear || time > globalEndYear);
      });
    }
    const hasMissingSector = hasTimeOutsidePeriod(phenomena, timeRanges);

    return (
      <Container
        style={{
          pointerEvents: loading.length ? "none" : "all",
          backgroundColor: !!isAIFCreatePreviewRadar && "transparent",
        }}
        ref={this.elmRadar}
      >
      <CustomToast isShow={hasMissingSector} canEditRadar={this.props.radarSettings.canEditRadar}/>
        <Loading shown={loading.length} color={"white"} />
        {this.renderTitle()}
        {!isAIFCreatePreviewRadar && this.renderBottomLeftNav()}
        {!isAIFCreatePreviewRadar && (
          <SideNav
            returnUri={returnUri}
            radarSettings={this.props.radarSettings}
            radarLogoLinkDisabled={this.props.radarLogoLinkDisabled}
          />
        )}
        {/* {
                    (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) !== true
                        && !!isNotInFullScreen)
                        ? <FullscreenIcon onClick={this.handleFullscreen} style={{cursor: 'pointer', color: 'white', position: 'absolute', bottom: 0, right: '15px', fontSize: '54px', zIndex: 999}}></FullscreenIcon> : ''
                }
                
                {
                    (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) !== true
                    && !isNotInFullScreen)
                    ? <FullscreenExitIcon onClick={this.handleExitFullScreen} style={{cursor: 'pointer', color: 'white', position: 'absolute', bottom: 0, right: '15px', fontSize: '54px', zIndex: 999}}></FullscreenExitIcon> : ''
                } */}

        {!isAIFCreatePreviewRadar &&
        /webOS|iPhone|iPad|iPod/i.test(navigator.userAgent) !== true &&
        (isInFullScreen === false || !isInFullScreen) ? (
          <button
            onClick={this.handleFullscreen}
            className="btn-fullscreen-custom"
            style={{ position: "fixed" }}
          >
            {/* <span>Fullscreen</span> */}
          </button>
        ) : null}

        {/* {
                    (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) !== true
                        && !!isNotInFullScreen)
                        ? <span 
                            className='af-custom-fullscreen'
                            onClick={this.handleFullscreen} style={{cursor: 'pointer', color: 'white', position: 'absolute', bottom: 0, right: '15px', fontSize: '32px', zIndex: 999}}></span> : ''
                } */}

        {/* {
                    (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) !== true
                    && !isNotInFullScreen)
                    ? <span 
                        className='af-custom-fullscreen_exit'
                        onClick={this.handleExitFullScreen} style={{cursor: 'pointer', color: 'white', position: 'absolute', bottom: 0, right: '15px', fontSize: '32px', zIndex: 999}}></span> : ''
                } */}

        {!isAIFCreatePreviewRadar &&
        /webOS|iPhone|iPad|iPod/i.test(navigator.userAgent) !== true &&
        (isInFullScreen === true || !!isInFullScreen) ? (
          <button
            onClick={this.handleExitFullScreen}
            className="btn-fullscreen-custom-exit"
            style={{ position: "fixed" }}
          >
            {/* <span>Fullscreen</span> */}
          </button>
        ) : null}

        {!isAIFCreatePreviewRadar && this.renderEditSectorMenu()}
        {this.renderRadar()}
        {!isAIFCreatePreviewRadar && this.renderSectorEditor()}
        {!isAIFCreatePreviewRadar && <SignalList />}
        {!isAIFCreatePreviewRadar && this.renderSandbox()}
        {!isAIFCreatePreviewRadar && (
          <TimeRangeEditorForm
            radarWidth={this.svg && this.svg.width.baseVal.value}
          />
        )}
        {!isAIFCreatePreviewRadar && this.renderEditPhenomenonForm()}
        {!isAIFCreatePreviewRadar && this.renderSockJsClient()}
        {!isAIFCreatePreviewRadar && this.renderCreateRadarModal()}
        {!isAIFCreatePreviewRadar && this.renderSectorDescriptionModal()}
        {!isAIFCreatePreviewRadar && this.renderDeleteRadarPhenomenonModal()}
        {!isAIFCreatePreviewRadar && <ConfirmDialog />}

        <a href='https://futuresplatform.com' target='_blank'>
          <svg id='radar-nav-fplogo' width="160" height="32" viewBox="0 0 329 24" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M4.91571 4.99495V9.37448H11.6419V13.6883H4.91571V23.491H0V0.616455H12.1918V4.99495H4.91571Z"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M36.6379 14.7355C36.6379 21.5936 32.0826 23.9999 27.0277 23.9999C21.9739 23.9999 17.4175 21.5936 17.4175 14.7355V0.460724H22.4714V14.339C22.4714 18.2303 24.4668 19.5807 27.0277 19.5807C29.5875 19.5807 31.584 18.2303 31.584 14.339V0.460724H36.6379V14.7355Z"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M51.5747 4.87787V23.5372H46.5197V4.87787H41.9645V0.460724H56.1299V4.87787H51.5747Z"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M80.6758 14.7355C80.6758 21.5936 76.1205 23.9999 71.0656 23.9999C66.0107 23.9999 61.4554 21.5936 61.4554 14.7355V0.460724H66.5093V14.339C66.5093 18.2303 68.5047 19.5807 71.0656 19.5807C73.6254 19.5807 75.6219 18.2303 75.6219 14.339V0.460724H80.6758V14.7355Z"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M94.9806 10.5816C97.707 10.5816 98.6713 9.19758 98.6713 7.71363C98.6713 6.22968 97.707 4.84564 94.9806 4.84564H92.8855V10.5816H94.9806ZM92.9852 14.9662H92.8855V23.5376H87.8316V0.460083H95.4124C101.464 0.460083 103.792 4.21991 103.792 7.71367C103.792 10.4165 102.396 13.2856 98.9705 14.4382L106.885 23.5376H100.201L92.9852 14.9662Z"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M116.933 4.87787V9.32867H123.85V13.6796H116.933V19.1211H124.415V23.5372H111.878V0.460724H124.415V4.87787H116.933Z"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M145.968 4.02084L142.776 7.05499C141.878 6.099 140.514 4.44888 138.054 4.44888C136.358 4.44888 135.493 5.24081 135.493 6.29567C135.493 7.41678 136.457 7.97734 137.722 8.63675L141.545 10.615C144.24 12.0001 146.034 14.3727 146.034 17.2081C146.034 20.868 143.075 24 138.187 24C132.766 24 129.773 20.1087 129.208 18.9213L132.433 15.823C133.065 17.0104 135.327 19.5808 138.155 19.5808C140.016 19.5808 141.046 18.4933 141.046 17.2081C141.046 15.8567 139.883 14.9669 137.688 13.8448L134.993 12.4607C132.166 10.9778 130.472 9.0974 130.472 6.42818C130.472 2.6368 133.831 0.000183105 138.054 0.000183105C141.978 0.000183105 144.307 2.24136 145.968 4.02084"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M166.926 10.5816H169.021C171.747 10.5816 172.712 9.19758 172.712 7.71363C172.712 6.22968 171.747 4.84564 169.021 4.84564H166.926V10.5816ZM169.453 0.460083C175.505 0.460083 177.832 4.21991 177.832 7.71367C177.832 11.2074 175.505 14.9662 169.453 14.9662H166.926V23.5376H161.871V0.460083H169.453Z"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M193.1 19.1211V23.5372H182.126V0.460724H187.181V19.1211H193.1Z"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M208.069 9.16472L205.84 16.2195H210.263L208.069 9.16472ZM204.544 20.3738L203.545 23.5373H198.59L205.907 0.460876H210.197L217.512 23.5373H212.557L211.56 20.3738H204.544Z"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M229.289 4.87787V23.5372H224.234V4.87787H219.678V0.460724H233.845V4.87787H229.289Z"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M244.388 4.87787V9.29607H251.306V13.648H244.388V23.5372H239.334V0.460724H251.871V4.87787H244.388Z"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M261.352 11.9998C261.352 16.5484 263.58 19.5489 267.504 19.5489C271.427 19.5489 273.656 16.5484 273.656 11.9998C273.656 7.44909 271.427 4.44859 267.504 4.44859C263.58 4.44859 261.352 7.44909 261.352 11.9998M278.71 11.9999C278.71 18.9559 273.888 23.9998 267.504 23.9998C261.119 23.9998 256.297 18.9559 256.297 11.9999C256.297 5.04291 261.119 0 267.504 0C273.888 0 278.71 5.04291 278.71 11.9999"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M290.355 10.5816C293.081 10.5816 294.045 9.19758 294.045 7.71363C294.045 6.22968 293.081 4.84564 290.355 4.84564H288.259V10.5816H290.355ZM288.36 14.9662H288.259V23.5376H283.206V0.460083H290.786C296.838 0.460083 299.167 4.21991 299.167 7.71367C299.167 10.4165 297.77 13.2856 294.345 14.4382L302.259 23.5376H295.575L288.36 14.9662Z"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M323.946 23.5373V7.25276L319.457 17.2071H315.433L310.976 7.25276V23.5373H305.923V0.460876H312.939L317.427 10.7465L322.316 0.460876H329V23.5373H323.946Z"></path>
        </svg>
        </a>

        <ErrorModal />
      </Container>
    );
  }
}

// const FullscreenBtn = styled.div`
//     color: white;
//     position: absolute;
//     bottom: 8px;
//     right: 30px;
//     background: white;
//     width: 40px;
//     height: 40px;
//     cursor: pointer;
//     z-index: 999;
// `

const FullscreenBtn = styled(Fullscreen)`
  color: white;
  position: absolute;
  bottom: 8px;
  right: 18px;
  // background: white;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 999;
`;

const ExitFullscreenBtn = styled(ExitFullscreen)`
  color: white;
  position: absolute;
  bottom: 8px;
  right: 18px;
  // background: white;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 999;
`;

const RadarTitle = styled.h1`
  color: white;
  position: absolute;
  top: 25px;
  left: 25px;
  margin: 0;
  text-shadow: 1.5px 1.5px 0 rgba(0, 0, 0, 0.2);
  max-width: 250px;
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: black;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RadarTitleLogo = styled.img`
    max-height: 85px;
    height: auto;
    width: auto;
    object-fit: contain;
    position: absolute;
    top: 25px;
    left: .9375rem;
`

export default RadarPage;
